import { analytics, regionUtils } from 'moet-core';
import { STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic';

const { region } = regionUtils;

export function logEvent(eventData, customData) {
  try {
    if (!eventData.properties.includes('region')) {
      eventData.properties.push('region');
    }
    return analytics.logEvent(eventData, { ...customData, region });
  } catch (e) {
    console.error('Failed to log event', e);
  }
}

/**
 * @param {object[]} allStakeholders
 * @param {STAKEHOLDER_ROLES_V2} role
 */
export function prepareStakeholderEventData(allStakeholders, role) {
  if (allStakeholders?.length) {
    const stakeholders = allStakeholders.filter(({ roles = [] }) =>
      roles.includes(STAKEHOLDER_ROLES_V2.ULTIMATE_BENEFICIAL_OWNER),
    );
    const numberOfStakeholders = stakeholders.length;
    const roles = stakeholders.map(({ roles }) => roles.join(',')).join(';');
    return { numberOfStakeholders, roles };
  } else return {};
}
